import { TOKEN_KEY } from 'src/Helpers/utils/Constant';
export const getToken = () => {
  if (typeof window === undefined) {
    return null;
  }

  return localStorage.getItem(TOKEN_KEY);
};
